export default class ParamStringBuilder {
	constructor(template, params) {
		this.template = template;
		this.params = {};
		if (params) {
			params.forEach(param => {
				this.params[param.name] = param.schema.enum !== undefined ? param.schema.enum[0] : '';
			});
		}
	}

	set(key, value) {
		this.params[key] = value;
	}

	toString() {
		let str = this.template.slice();
		Object.keys(this.params).forEach(key => {
			str = str.replace('{' + key + '}', this.params[key]);
		});
		return str;
	}
}
